import { ComboBox } from "@progress/kendo-react-dropdowns";
import React, { useState } from "react";
import { operators } from "../../constant";
import { DateTimePicker } from "@progress/kendo-react-dateinputs";
import CreatableSelect from "react-select/creatable";
import { useTranslation } from "react-i18next";

const ColumnMenuFilter = (props) => {
  const defaultValue = {
    sensorName: "",
    severity: [],
    sensorValue: { operator: "=", value: null },
    status: [],
    timeStamp: { start: null, end: null },
    acknowledgeTime: {
      start: null,
      end: null,
    },
    clearedTime: {
      start: null,
      end: null,
    },
    acknowledgeUser: "",
    clearedUser: "",
    lastStatus: [],
    assetName: [],
  };
  const [filterPayload, setFilterPayload] = useState(
    props.filterData || defaultValue
  );
  const { t } = useTranslation();

  const handleTextChange = (e) => {
    setFilterPayload((pre) => ({ ...pre, [e.target.name]: e.target.value }));
  };

  const onMultiSelectChange = (e, name) => {
    setFilterPayload((pre) => ({
      ...pre,
      [name]: e,
    }));
  };

  const onCompoBoxChange = (e, field) => {
    setFilterPayload((pre) => ({
      ...pre,
      [e.target.name]: {
        ...pre[e.target.name],
        [field]: e.target.value,
      },
    }));
  };

  const onReset = (field) => {
    props.setFilterData((pre) => ({ ...pre, [field]: defaultValue[field] }));
    props.onCloseMenu();
  };

  const onSubmit = () => {
    props.setFilterData(filterPayload);
    props.onCloseMenu();
  };

  // useEffect(() => {
  //   setFilterPayload(props.filterData);
  // }, []);
  return (
    <div className="p-1 flex flex-col items-center w-full gap-1 bg-[#2b334a] border-none ring-0">
      {props.type === "textbox" ? (
        <input
          type="text"
          id="text"
          name={props.column.field}
          value={filterPayload[props.column.field]}
          onChange={handleTextChange}
          className="block w-full pl-3 pr-10 py-2 h-7 text-base bg-[#363945] text-white border-gray-500 focus:outline-none sm:text-sm rounded-md"
        />
      ) : props.type === "dropdown" ? (
        <div className="w-full" id="compo">
          <CreatableSelect
            isMulti
            options={props.data}
            theme={(theme) => ({
              ...theme,
              colors: {
                ...theme.colors,
                primary25: "rgb(107,114,128)",
                primary: "black",
              },
            })} // textField="labal"
            className="text-white bg-zinc-700 border-transparent rounded-xl w-full"
            // name={props.column.field}
            style={{
              padding: "0px",
              width: "100%",
              borderColor: "transparent",
            }}
            // dataItemKey="id"
            value={filterPayload[props.column.field]}
            onChange={(e) => onMultiSelectChange(e, props.column.field)}
          />
        </div>
      ) : props.type === "number" ? (
        <div className="flex gap-1 w-full">
          <ComboBox
            className="w-24"
            placeholder="Operator"
            name={props.column.field}
            value={filterPayload[props.column.field]?.operator}
            style={{ padding: "0px", width: "100%" }}
            clearButton={false}
            onChange={(e) => onCompoBoxChange(e, "operator")}
            data={operators}
          />
          <input
            type="number"
            name={props.column.field}
            value={filterPayload[props.column.field]?.value}
            className="bg-[#363945] rounded text-white px-4 outline-none w-full ring-0"
            onChange={(e) => onCompoBoxChange(e, "value")}
          />
        </div>
      ) : props.type === "date" ? (
        <div className="flex flex-col gap-1">
          <DateTimePicker
            className="md:h-7 h-5 w-full md:text-xs text-xxs placeholder:text-white"
            placeholder="Start Range"
            format="dd-MM-yyyy hh:mm a"
            name={props.column.field}
            min={props.defaultFilter ? props.defaultFilter.startDate : null}
            max={props.defaultFilter ? props.defaultFilter.endDate : null}
            value={filterPayload[props.column.field]?.start}
            onChange={(e) => onCompoBoxChange(e, "start")}
          />
          <DateTimePicker
            className="md:h-7 h-5 w-full md:text-xs text-xxs placeholder:text-white"
            placeholder="End Range"
            format="dd-MM-yyyy hh:mm a"
            min={props.defaultFilter ? props.defaultFilter.startDate : null}
            max={props.defaultFilter ? props.defaultFilter.endDate : null}
            name={props.column.field}
            value={filterPayload[props.column.field]?.end}
            onChange={(e) => onCompoBoxChange(e, "end")}
          />
        </div>
      ) : null}
      <div className="flex gap-1 w-full px-1">
        <button
          onClick={() => onReset(props.column.field)}
          className="bg-red-400 text-white p-2 h-7 w-1/2 shrink-0 flex justify-center items-center rounded-md"
        >
          <img src="NotFilter.svg" alt="NotFilter" className="h-4 w-5 flex-shrink-0" />
          {t("button.reset")}
        </button>
        <button
          onClick={onSubmit}
          className="bg-indigo-600 disabled:opacity-40 text-white p-2 w-1/2 h-7 shrink-0 flex justify-center items-center rounded-md"
          disabled={
            props.type === "date" &&
            (filterPayload[props.column.field]?.end === null ||
              filterPayload[props.column.field]?.start === null)
          }
        >
          <img src="filter-icon.svg" alt="FilterIcon" className="h-4 w-5 flex-shrink-0" />
          {t("button.filter")}
        </button>
      </div>
    </div>
  );
};

export default ColumnMenuFilter;
